import React, { useState } from 'react';

import { Row, Column } from 'react-foundation';

const UnsubcribeTab = (props) => {
	const [active, setActive] = useState(false);

	const toggle = () => {
		setActive(!active);
	};

	return (
		<div>
			<button className="accordion card" onClick={toggle}>
				<div className="account-card-title">
					{props.subscribed ? 'Unsubscribe' : 'Subscribe'}
				</div>
				<div className="account-card-text">
					{props.subscribed
						? 'Learn about what you will miss!'
						: 'Subscribe now for exclusive content and recommendations'}
					Learn about what you will miss!
				</div>
				<div className="arrow-holder">
					<div className={active ? 'arrow active' : 'arrow'} />
				</div>
			</button>
			<div className={active ? 'dropdown active' : 'dropdown'}>
				<Row>
					<Column small={12}>
						<div className="header">
							{props.subscribed
								? 'Are you sure you wish to unsubscribe?'
								: 'Subscribe now!'}
						</div>
						<ul className="bullet-points">
							<li className="bp">
								{props.subscribed
									? 'If you unsubscribe now, you will no longer have access to the list of matches we curate for you'
									: 'Access to the list of matches we curate for you'}
							</li>
							<li className="bp">
								{props.subscribed
									? 'You will no longer be able to unlock contracts and certain sponsorship insights'
									: 'Unlock contacts and certain sponsorship insights'}
							</li>
						</ul>
					</Column>
				</Row>
				<Row>
					<Column small={12}>
						<div className="button-holder">
							<div
								className={
									props.subscribed
										? 'purchase-button long'
										: 'purchase-button long'
								}
								onClick={props.toggleModal}
							>
								<p>
									{props.subscribed
										? 'UNSUBSCRIBE'
										: 'SUBSCRIBE'}
								</p>
							</div>
						</div>
					</Column>
				</Row>
			</div>
		</div>
	);
};

export default UnsubcribeTab;
